import React from "react";
import { ClearTable } from "./styles";
import moment from "moment";
import PropTypes from 'prop-types';

export default class Pricetable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      priceTable: []
    };
  }
  componentWillMount() {
    this.setData(this.props.data);
  }
  componentWillReceiveProps(nextProps) {
    this.setData(nextProps.data);
  }

  formatDate(date) {
    if(date) {
      let datePart = date.split("-");
      return datePart[1] + "/" + datePart[2] + "/" + datePart[0];
    }
  }

  setData = tableData => {
    const data = [];
    if (tableData.length !== 0) {
      tableData &&
        tableData.forEach((item) => {
          data.push({
            Date: moment(moment.tz(item.date, "America/New_York")).format("L"),
            unitPrice: `$${parseFloat(item.unitPrice).toFixed(2)}`
          });        

          this.setState({
            priceTable: data
          });
        });
    } else {
      this.setState({ priceTable: data });
    }
  };

  render() {    
    const columns = [
      {
        title: () => <div className="navy-color">Date</div>,
        dataIndex: "Date",
        key: "Date",
        width: 155
      },
      {
        title: () => (
          <div className="navy-color">
            Unit Price
          </div>
        ),
        dataIndex: "unitPrice",
        key: "unitPrice",
        className: "price-table-unit-price"
      }
    ];
    const {tabName} = this.props
    return (
      <div>
        <ClearTable
          className="historicalNAVTable iodClearTable"
          columns={columns}
          dataSource={this.state.priceTable}
          pagination={false}
          scroll= {{y: tabName === "vdi" ? 375 : 270}}
        />
      </div>
    );
  }
}

Pricetable.propTypes = {
  accountType: PropTypes.string,
  data: PropTypes.array,
  loader: PropTypes.bool
}
